const consts = {
    default_route: '/users',
    fetchAppProps: {
        dispatches: [
            {name: 'fetchUserSettings', params: {}},
            {name: 'fetchUnitsIcons', params: {}},
            {name: 'fetchUnitsHwTypesAll', params: {}},
            {name: 'fetchUnitsHwTypesSettings', params: {}},
            {name: 'fetchSmsGatewayTypes', params: {}},
            {name: 'fetchUnitsTypes', params: {}},
            {name: 'fetchUnitsXTypes', params: {}},
            {name: 'fetchUnitsOfMeasures', params: {}},
            {name: 'fetchUsersProfilesAll', params: {}},

            {name: 'fetchAppUser', params: {}},

            {name: 'fetchAppObjects', params: [
                {name: 'fetchUnitsLmsgsAll', params: {withAddress: 0, withSensors: 1}},
                {name: 'fetchVideoStatusesAll', params: {}},
                {name: 'fetchUnitsAll', params: {}},

                {name: 'fetchUnitsGroupsAll', params: {}},

                {name: 'fetchUsersAll', params: {}},
                {name: 'fetchUsersCustomizesAll', params: {}},
            ]},

            {name: 'fetchSensorsAll', params: {}},
        ],
    },
    reloadAppProps: {
        dispatches: [
            {name: 'reloadUnitsAll', params: {}},
            {name: 'reloadUnitsLmsgsAll', params: {withAddress: 0, withSensors: 1}},
            {name: 'fetchVideoStatusesAll', params: {}},
        ],
        commits: [
        ],
    },
    fetchByTimer: {
        dispatches: [
            //{name: 'fetchAppUserChanged', eachT: 30, params: {}},

            {name: 'fetchUnitsChanged', eachT: 30, params: {}},
            {name: 'fetchUnitsLmsgsChanged', eachT: 30, params: {lite: true, withAddress: 0, withSensors: 0}},//'filter[changed]': 60,
            {name: 'fetchVideoStatusesChanged', eachT: 30, params: {}},

            {name: 'fetchUnitsGroupsChanged', eachT: 30, params: {}},

            {name: 'fetchUsersChanged', eachT: 30, params: {}},
            {name: 'fetchUsersCustomizesChanged', eachT: 30, params: {}},

            {name: 'fetchSensorsChanged', eachT: 30, params: {}},
        ],
    },
    api: {
        sensors: {
            fields: ['id', 'id_unit', 'type', 'name', 'msg_param', 'conversion', 'measure', 'units_of_measure', 'round', 'enum', 'is_visible', 'options', 'changed__time'],
        },

        units_lite: {
            fields: ['id','creator','hw_type','hw_id','name','isRemoved','access_right','parent__id'],
            expand: ['user_creator', 'created', 'access_right'], //,counters
        },
        units: {
            //fields: ['id','hw_type','hw_id','name','type','unit_icon','icon','max_speed','phone'],
            expand: ['user_creator', 'created', 'removed', 'access_right', 'dimensions', 'axle_count', 'truck_type', 'cameras', 'camera_time_zone', 'sensors'], //,counters, 'video'
        },

        units_groups_lite: {
            fields: ['id', 'name', 'icon'],
            expand: [],
        },
        units_groups: {
            // fields: ['id',],
            expand: ['access_right','user_creator'],
        },

        unitslmsgs_lite: {
            fields: ['object_id', 'unit_id', 'id_unit', 'hw_type', 'hw_id', 'time', 'speed', 'course', 'time_speed', 'latlng', 'timeAgo', 'status', 'sensors'],
            //expand: [],
        },
        unitslmsgs: {
            // fields: ['id',],
            expand: ['access_right'],
        },

        users_lite: {
            fields: ['id','creator','login','email','phone','status','status_text'],
            expand: ['user_creator', 'is_admin', 'is_super_admin'],
        },

        user: {
            //fields: [],
            expand: [
                'units_of_measure', 'settings', 'notifications_settings', 'user_creator', 'is_admin', 'is_super_admin', 'parents',
                'hide_menu', 'dealers_hide_menu', 'admin_hide_menu', 'dealers_admin_hide_menu', 'head__logo', 'sender_mail', 'created',
                'location', 'cost_unit', 'cost_mode', 'cost_day', 'currency', 'lat_lon', 'portal_url', 'admin_url', 'portal_legacy_url', 'shifts', 'orchestrator', //'following_time'
            ],
        },
        users: {
            //fields: ['id','creator','login','email','phone','legal_name','time_zone','dst','status'],
            expand: [
                'user_creator', 'is_admin', 'is_super_admin', 'parents', 'apikeys',
                'hide_menu', 'admin_hide_menu', 'last__login', 'created',//'portal_url', 'admin_url', 'portal_legacy_url',
                'location', 'cost_unit', 'cost_mode', 'cost_day', 'currency', 'lat_lon', 'sender_mail', 'orchestrator'
            ],//, 'customize'
        },

        customizes_lite:{
            fields: ["id_user","user_id","url","dns","site_name","support_email"],
            expand: [],
        },
        customizes:{
            //fields: [],
            expand: ['smtp_config'],
        },

        geopoints_lite: {
            fields: ['id', 'name', 'lat', 'lon', 'icon'],
            // expand: [],
        },
        geopoints: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'],
        },

        geopoints_groups_lite: {
            fields: ['id', 'name', 'geopoints'],
            // expand: [],
        },
        geopoints_groups: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'],
        },

        geozones_lite: {
            fields: ['id', 'name', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            // expand: [],
        },
        geozones: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'],
        },

        geozones_groups_lite: {
            fields: ['id', 'name', 'geozones'],
            // expand: [],
        },
        geozones_groups: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'],
        },

        notifications: {
            //fields: [],
            expand: ['units', 'units-groups', 'geozones', 'geopoints', 'user_creator'],
        },
        template_reports: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        services: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        drivers: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        drivers_groups: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        hw_types_lite: {
            //fields: [],
            expand: ['sensors'],
        },
        hw_types: {
            //fields: [],
            expand: ['sensors'],
        },

        units_msgs: {
            // fields: ['id',],
            expand: [],
        },

        events: {
            //fields: [],
            expand: [],
        },
        events_lite: {
            //fields: [],
            expand: [],
        },
        video_events: {
            //fields: [],
            expand: [],
        },
        video_events_lite: {
            //fields: [],
            expand: [],
        },
        video_requests: {
            //fields: [],
            expand: ['image'],
        },
        video_requests_lite: {
            //fields: [],
            expand: [],
        },
        video_records: {
            //fields: [],
            expand: [],
        },
        video_records_lite: {
            //fields: [],
            expand: [],
        },

    },
    components: {
        UnitEdit: {
            defaults: {
                options: {
                    components: [
                        'UnitEdit_Options_prometheus',
                        'UnitEdit_Characteristics',
                        'UnitEdit_Camera_prometheus',
                        //'UnitEdit_Locks_prometheus',
                        'UnitEdit_Properties_prometheus',
                    ]
                },
            },
            xCargoUnit: {
                options: {
                    components: [
                        'UnitEdit_Options_prometheus',
                        'UnitEdit_Delivery',
                        'UnitEdit_xCargoSensors',
                    ]
                }
            }
        },
        UserEdit: {
            defaults: {
                options: {
                    components: [
                        'UserEdit_Options_prometheus',
                        //'UserEdit_Cost_prometheus',
                        'UserEdit_Menus',
                        'UserEdit_Api_prometheus',
                        'UserEdit_Orchestrator',
                        'UserEdit_Sms',
                        //'UserEdit_Password',
                    ]
                }
            }
        },
        UserServicesEdit: {
            defaults: {
                options: {
                    components: [
                        'UserServicesEdit_list_services',
                        'UserServicesEdit_service_ComplianceBox',
                        'UserServicesEdit_service_NoCell',
                        'UserServicesEdit_service_WliusELD',
                        'UserServicesEdit_service_ApolloELD',
                        'UserServicesEdit_service_Argus',
                        'UserServicesEdit_service_Geotab',
                    ]
                }
            }
        },
        UserCustomizeEdit: {
            defaults: {
                options: {
                    components: [
                        'UserCustomizeEdit_options',
                    ]
                }
            }
        },
    },
}

export default consts